import styled from 'styled-components';
import { spacing, colors, fontWeights, link2, letterSpacing, fontSizes } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PreviewContainer = styled.section`
  border-radius: ${spacing.quarter};
  border: ${spacing.single} solid ${colors.grey15};
  padding: ${spacing.threeQuarter};
  width: 100%;
  position: relative;
  margin-bottom: ${spacing.half};
`;

export const EmptyTextContainer = styled.div`
  align-items: center;
  background: ${colors.grey5};
  border-radius: ${spacing.quarter};
  display: flex;
  height: ${pxToRem(170)};
  justify-content: center;
  padding: 10%;
  text-align: center;
`;

export const EmptyPreviewContainer = styled(EmptyTextContainer)`
  flex-direction: column;
  gap: ${spacing.base};
  height: ${pxToRem(199)};
  color: ${colors.textSecondary};
`;

export const ButtonContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  right: ${spacing.plusHalf};
  bottom: ${pxToRem(23)};
  gap: ${spacing.quarter};
`;

export const StyledLink = styled.span`
  ${link2}
  margin-top: ${spacing.half};
  float: right;
  font-size: ${fontSizes.s12};
  font-weight: ${fontWeights.regular};
  line-height: ${fontSizes.s16};
  letter-spacing: ${letterSpacing.pos10};
`;
